(function () {
  var GOLD = 'rgb(201, 168, 76)';
  var GOLD_BG = 'rgba(201, 168, 76, 0.15)';

  function patchBars() {
    document.querySelectorAll('.star-range').forEach(function (el) {
      var bg = el.style.background;
      if (!bg) return;
      el.style.background = bg
        .replace(/rgb\(255,\s*168,\s*0\)/g, GOLD)
        .replace(/rgb\(230,\s*230,\s*230\)/g, GOLD_BG);
    });
  }

  function init() {
    patchBars();
    var root = document.getElementById('seal-review-widget');
    if (!root) return;
    new MutationObserver(patchBars).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
